import { currencySymbols } from 'constants/currencies';

export function formatEuropeanCurrency(
  value: number | string | undefined | null,
  currencyCode: string = 'EUR',
  includeSymbol: boolean = false
): string {
  if (value === undefined || value === null || value === '') return '';

  // Normalize input to number; support raw (e.g., 482052.5) and EU style (e.g., 482.052,50)
  const raw = String(value).replace(/[^0-9,.'-]/g, '');
  let normalized = raw;
  if (raw.includes(',') && raw.includes('.')) {
    // Assume dots are thousand separators and comma is decimal
    normalized = raw.replace(/\./g, '').replace(',', '.');
  } else if (raw.includes(',')) {
    // Only comma present -> treat as decimal separator
    normalized = raw.replace(/,/g, '.');
  }
  // Remove apostrophes used as thousand separators if any
  normalized = normalized.replace(/'/g, '');

  const num = Number(normalized);

  if (!Number.isFinite(num)) return '';

  const sign = num < 0 ? '-' : '';
  const abs = Math.abs(num);

  const fixed = abs.toFixed(2); // e.g., "482052.00"
  const [intPart, decPart] = fixed.split('.');

  // Insert apostrophes as thousands separators
  const intWithThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, "'");

  const base = `${sign}${intWithThousands},${decPart}`;
  if (!includeSymbol) return base;

  const symbol = currencySymbols[currencyCode as keyof typeof currencySymbols] || currencyCode;
  return `${base} ${symbol}`.trim();
}
